module.exports = __webpack_public_path__ + "static/media/CentroMedicoBazterica.7421c0c9.svg";